import { render, staticRenderFns } from "./DialogCalificacionModulo.vue?vue&type=template&id=1311bdc6&scoped=true"
import script from "./DialogCalificacionModulo.vue?vue&type=script&lang=js"
export * from "./DialogCalificacionModulo.vue?vue&type=script&lang=js"
import style0 from "./DialogCalificacionModulo.vue?vue&type=style&index=0&id=1311bdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311bdc6",
  null
  
)

export default component.exports